<template>
  <button
    :type="type"
    class="cta cta--secondary"
    :class="{ 'cta--block': block }"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  block?: boolean;
}>(), { type: 'button', block: true });
defineEmits<{ click: [MouseEvent] }>();
</script>

<style scoped lang="scss">
.cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 22px;
  border-radius: var(--radius-pill);
  font-weight: 600;
  font-size: 14.5px;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: opacity var(--dur-fast), background var(--dur-fast);
  min-height: 48px;

  &:active:not(:disabled) { background: var(--bg-card); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.cta--block { width: 100%; }

.cta--secondary {
  background: transparent;
  color: var(--text);
  border: 1px solid var(--hairline-strong);
}
</style>
